import { render, staticRenderFns } from "./GroupStatisticTemplateMetric.vue?vue&type=template&id=16741c78&scoped=true"
import script from "./GroupStatisticTemplateMetric.vue?vue&type=script&lang=js"
export * from "./GroupStatisticTemplateMetric.vue?vue&type=script&lang=js"
import style0 from "./GroupStatisticTemplateMetric.vue?vue&type=style&index=0&id=16741c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16741c78",
  null
  
)

export default component.exports